import { datadogRum } from '@datadog/browser-rum';
import { getEnv } from "../utils/api";

export class DataDog {
  env;
  appId = '7bc31d05-eeb8-40bb-8470-f32164606297';
  token = 'pub5caa6bdc4ba2ea22fec8c691ac1746a0';
  site = 'us3.datadoghq.com';
  service = 'nlhr';

  constructor(applicationId) {
    this.env = getEnv(applicationId);
  }

  initialize() {
    datadogRum.init({
      applicationId: this.appId,
      clientToken: this.token,
      site: this.site,
      service: this.service,
      env: this.env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: 100,
      sessionReplaySampleRate: 0,
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel:'mask-user-input'
    });
    datadogRum.startSessionReplayRecording();
  }
}
